<div class="user-om">
  <div class="user-om__header">{{ title() }}</div>
  <div class="user-om__separator"></div>
  <div class="user-om__options">
    @for (option of options(); track option.value) {
      <button
        type="button"
        class="user-om__option"
        [class.user-om__option--selected]="option.value === selectedValue()"
        (click)="onSelect(option.value)"
      >
        <span class="user-om__option__text">{{ option.label }}</span>
        @if (option.value === selectedValue()) {
          <img src="public/icons/actions/check-icon.svg" alt="" />
        }
      </button>
    }
  </div>
</div>
